import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/PageHeader/PageHeader';

import { ReactComponent as BusinessIcon }      from '../../assets/site-assets/service/Business.svg';
import { ReactComponent as TransportIcon }     from '../../assets/site-assets/service/Transport.svg';
import { ReactComponent as UtilitiesIcon }     from '../../assets/site-assets/service/Utilities.svg';
import { ReactComponent as SocialSupportIcon } from '../../assets/site-assets/service/Social Support.svg';
import { ReactComponent as GeneralIcon }       from '../../assets/site-assets/service/General.svg';
import { ReactComponent as SecurityIcon }      from '../../assets/site-assets/service/Security.svg';

import ServiceBg from '../../assets/site-assets/service/bg.png';
import './ServicesPage.scss';

const serviceIcons = [BusinessIcon, TransportIcon, UtilitiesIcon, SocialSupportIcon, GeneralIcon, SecurityIcon];

const ServicesPage = () => {
  const { t } = useTranslation();
  return (
    <div className="services-page">

      <PageHeader bgImage={ServiceBg} title={t('services.pageTitle')} />

      <section className="services-icons">
        <div className="services-container">
          <div className="services-icons__grid">
            {serviceIcons.map((Icon, i) => (
              <a key={i} href={t(`services.links.${i}`)} className="services-icons__item">
                <Icon className="services-icons__icon" aria-hidden="true" />
                <span className="services-icons__label">{t(`services.categories.${i}`)}</span>
              </a>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default ServicesPage;
